import React from 'react';
import './Description.css';

interface DescriptionProps {
  lines: string[];
  bold?: boolean;
}

function Description({ lines, bold }: DescriptionProps): React.ReactNode {
  return (
    <p className={`description ${bold && 'bold'}`}>
      {lines.map((line, i) => (
        <span key={i} className="line">
          {line}
        </span>
      ))}
    </p>
  );
}

export default Description;
